export const typographyConstants = {
	/**
	 * Good as a placeholder for a line of text that can be empty and for
	 * synthetic line breaks.
	 */
	zeroWidthSpace: '\u200B',
};
